import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const UserDirectoryRoute = lazyWithRetries(() => import('.'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.people(),
    element: (
      <StandardPageLayout
        elementId="userDirectoryRoute"
        maxWidth={1080}
        title={<T _str="People" />}>
        <Suspense fallback={<RouteLoading />}>
          <UserDirectoryRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
